import FuseDialog from '@fuse/core/FuseDialog';
import FuseMessage from '@fuse/core/FuseMessage';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from 'app/AppContext';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import FooterLayoutFinanceiro from './components/FooterLayoutFinanceiro';
import LeftSideLayoutFinanceiro from './components/LeftSideLayoutFinanceiro';
import NavbarWrapperLayoutFinanceiro from './components/NavbarWrapperLayoutFinanceiro';
import RightSideLayoutFinanceiro from './components/RightSideLayoutFinanceiro';
import ToolbarLayoutFinanceiro from './components/ToolbarLayoutFinanceiro';

/**
  Para modificar a propriedade scroll do layout
  
  const settings = useSelector(({ fuse }) => fuse.settings.current);
  const dispatch = useDispatch();

  useEffect(() => {
    const newSettings = _.set(_.merge({}, settings), 'layout.config.scroll', false); // 'content' habilita, false desabilita

    dispatch(Actions.setSettings(newSettings));
  }, []);
 */
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    '&.boxed': {
      maxWidth: 1280,
      margin: '0 auto',
      boxShadow: theme.shadows[3],
    },
    '&.container': {
      '& .container': {
        maxWidth: 1120,
        width: '100%',
        margin: '0 auto',
      },
      '& .navigation': {},
    },
  },
  content: {
    display: 'flex',
    overflow: 'auto',
    flex: '1 1 auto',
    flexDirection: 'column',
    width: '100%',
    '-webkit-overflow-scrolling': 'touch',
    zIndex: 4,
  },
  toolbarWrapper: {
    display: 'flex',
    position: 'relative',
    zIndex: 5,
  },
  toolbar: {
    display: 'flex',
    flex: '1 0 auto',
  },
  footerWrapper: {
    position: 'relative',
    zIndex: 5,
  },
  footer: {
    display: 'flex',
    flex: '1 0 auto',
  },
}));

function LayoutFinanceiro(props) {
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);

  const classes = useStyles(props);

  return (
    <AppContext.Consumer>
      {({ routes }) => (
        <div id="fuse-layout" className={clsx(classes.root, config.mode)}>
          {config.leftSidePanel.display && <LeftSideLayoutFinanceiro />}

          <div className="flex flex-1 flex-col overflow-hidden relative">
            {config.toolbar.display && config.toolbar.position === 'above' && <ToolbarLayoutFinanceiro />}

            {config.navbar.display && <NavbarWrapperLayoutFinanceiro />}

            {config.toolbar.display && config.toolbar.position === 'below' && <ToolbarLayoutFinanceiro />}

            {config.scroll ? (
              <FuseScrollbars className={classes.content} scrollToTopOnRouteChange>
                <FuseDialog />

                <div className="flex flex-auto flex-col relative h-full">
                  <FuseSuspense>{renderRoutes(routes)}</FuseSuspense>

                  {props.children}

                  {config.footer.display && config.footer.style === 'static' && <FooterLayoutFinanceiro />}
                </div>
              </FuseScrollbars>
            ) : (
              <div className={classes.content}>
                <FuseDialog />

                <div className="flex flex-auto flex-col relative h-full">
                  <FuseSuspense>{renderRoutes(routes)}</FuseSuspense>

                  {props.children}

                  {config.footer.display && config.footer.style === 'static' && <FooterLayoutFinanceiro />}
                </div>
              </div>
            )}

            {config.footer.display && config.footer.style === 'fixed' && <FooterLayoutFinanceiro />}
          </div>

          {config.rightSidePanel.display && <RightSideLayoutFinanceiro />}

          <FuseMessage />
        </div>
      )}
    </AppContext.Consumer>
  );
}

export default LayoutFinanceiro;
